'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const ParcelLockersIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.1 6.50001C18.3 6.50001 18.5 6.30001 18.5 6.10001C18.5 5.90001 18.3 5.70001 18.1 5.70001C17.9 5.70001 17.7 5.90001 17.7 6.10001C17.7 6.30001 17.9 6.50001 18.1 6.50001Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M18.3 6.39999H18V6.89999H18.3V6.39999Z", fill: "currentColor" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.1 22H3C2.4 22 2 21.6 2 21V4.89999C2 4.29999 2.4 3.89999 3 3.89999H14.4V9.59999H20.1V21C20.1 21.6 19.7 22 19.1 22ZM14.4 21H19.1V16.3H14.4V18.1H15.9V19.1H14.4V21ZM8.7 21H13.4V16.3H8.7V18.1H10.2V19.1H8.7V21ZM3 19.1V21H7.7V16.3H3V18.1H4.5V19.1H3ZM14.4 15.3H19.1V10.6H14.4V12.4H15.9V13.4H14.4V15.3ZM8.7 15.3H13.4V10.6H8.7V12.4H10.2V13.4H8.7V15.3ZM3 15.3H7.7V10.6H3V12.4H4.5V13.4H3V15.3ZM8.7 9.59999H13.4V4.89999H8.7V6.79999H10.2V7.79999H8.7V9.59999ZM3 9.59999H7.7V4.89999H3V6.79999H4.5V7.79999H3V9.59999ZM20.1 8.69999H16.1C15.5 8.69999 15.1 8.29999 15.1 7.69999V4.89999C15.1 4.29999 15.5 3.89999 16.1 3.89999H16.3C16.3 2.99999 16.9 2.19999 17.8 2.09999C18.3 1.99999 18.9 2.19999 19.3 2.49999C19.7 2.79999 19.9 3.29999 19.9 3.89999V3.99999H20.1C20.7 3.99999 21.1 4.39999 21.1 4.99999V7.79999C21.1 8.19999 20.7 8.69999 20.1 8.69999ZM16.1 7.69999H20.1V4.89999H16.1V7.69999ZM17.3 3.89999H18.9V3.79999C18.9 3.59999 18.8 3.29999 18.6 3.19999C18.5 2.99999 18.2 2.89999 18 2.99999C17.6 2.99999 17.3 3.39999 17.3 3.89999Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpParcelLockersIcon = forwardRef(ParcelLockersIcon);

export { VpParcelLockersIcon as default };
